import { useNavigate } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";
import { Button } from "@mui/material";
import IfCan from "../../../components/IfCan";
import {
  ResponsiveContainer,
  Tooltip,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Bar,
  LineChart,
  Line,
  PieChart,
  Pie,
  Cell,
  Legend,
} from "recharts";
import MainContainer from "../../../layout/MainContainer";

const waterLogData = [
  { name: "Mon", value: 7 },
  { name: "Tue", value: 5 },
  { name: "Wed", value: 6 },
  { name: "Thu", value: 8 },
  { name: "Fri", value: 7 },
  { name: "Sat", value: 4 },
  { name: "Sun", value: 5 },
];

const mealTimeData = [
  { name: "8 AM", count: 3 },
  { name: "1 PM", count: 5 },
  { name: "7 PM", count: 6 },
  { name: "9 PM", count: 2 },
];

const moodData = [
  { name: "Happy", count: 40 },
  { name: "Sad", count: 15 },
  { name: "Angry", count: 10 },
  { name: "Crying", count: 5 },
  { name: "Excited", count: 20 },
];

const skippedGoalsData = [
  { name: "Exercise", count: 8 },
  { name: "Meditation", count: 5 },
  { name: "Meal Plan", count: 3 },
  { name: "Water Intake", count: 2 },
];

const COLORS = ["#0088FE", "#FF8042", "#FF6384", "#4BC0C0", "#00C49F"];

const WellnessLifestyle = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="main_title d_flex">
        <div className="left_s">
          <h1>Wellness & Lifestyle Trends</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Wellness & Lifestyle Trends
          </p>
        </div>
        <div className="right_s">
          <IfCan module="Manage Analytics" action="add_edit">
            <Button className="btn btn_primary">
              <DownloadIcon /> Export
            </Button>
          </IfCan>
        </div>
      </div>

      <div className="grid_sc gap_m">
        {/* 1. Avg. Water Logged */}
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Avg. Water Logged (Liters)</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={waterLogData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="value" fill="#38B6FF" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* 2. Common Meal Times */}
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Common Meal Times</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={mealTimeData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count" fill="#FF8042" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* 3. Avg. Mood Logs (Bar Chart) */}
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Avg. Mood Logs</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={moodData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count">
                {moodData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* 4. Most Skipped Goals */}
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Most Skipped Goals</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={skippedGoalsData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count" fill="#FF6384" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
};

export default WellnessLifestyle;
